module.exports = __webpack_public_path__ + "static/media/Scallywag Pirate.89053f8d.jpg";